import { LoadingButton } from '@mui/lab'
import { Dialog, DialogActions, DialogContent, Box, TextField } from '@mui/material'
import { useForm } from 'react-hook-form'
import { FC } from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { useGlobalSnackbarStore } from '../../store/GlobalSnackBarStore'
import { PATHS } from '../PATHS'
import { AuthClient } from '../../interactors/clients/AuthClient'

export const ResetPasswordPage: FC = () => {
  const navigate = useNavigate()
  const globalSnackbar = useGlobalSnackbarStore()

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<{ newPassword: string; confirmPassword: string }>()

  const validatePasswordsMatch = (value: string) => {
    if (value !== watch('newPassword')) {
      return 'Les mots de passe ne correspondent pas'
    }
  }

  const validatePassword = (value: string) => {
    if (value.length < 2) {
      return 'Le mot de passe doit au moins contenir 8 caractères'
    }
  }

  // Mutation qui permet de modifier le mot de passe
  const mutation = useMutation(
    async (params: { resetToken: string; newPassword: string }) => {
      await AuthClient.resetPassword(params.resetToken, params.newPassword)
    },
    {
      onSuccess: () => {
        navigate(PATHS.login.absolute)
        globalSnackbar.triggerSuccessMessage(`Votre mot de passe a bien été réinitialiser !`)
      },
    }
  )

  const onSubmit = ({ newPassword }: { newPassword: string }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mutation.mutate({ newPassword, resetToken: new URLSearchParams(window.location.search).get('token')! })
  }

  return (
    <>
      <Dialog open={true}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Box marginBottom={4}>Veuillez entrer un nouveau mot de passe:</Box>
            <Box display="flex" justifyContent="center">
              <TextField
                id="new-password-input"
                label="Nouveau mot de passe"
                type="password"
                InputLabelProps={{ shrink: true }}
                error={!!errors.newPassword}
                helperText={errors.newPassword?.message}
                sx={{ width: '100%' }}
                {...register('newPassword', { validate: validatePassword })}
              />
            </Box>
            <Box display="flex" justifyContent="center" sx={{ marginTop: 2 }}>
              <TextField
                id="confirm-password-input"
                label="Confirmer le mot de passe"
                type="password"
                InputLabelProps={{ shrink: true }}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword?.message}
                sx={{ width: '100%' }}
                {...register('confirmPassword', { validate: validatePasswordsMatch })}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <LoadingButton
              data-testid="apply-changes"
              variant="contained"
              type="submit"
              //   sx={{ backgroundColor: 'error.main' }}
              loading={mutation.isLoading}
            >
              Valider
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
